import '../views/administration/accounts/overview.html';

import { EDITROUTE, EDITTITLE } from '../views/administration/accounts/EditAccountController';
import { ADDROUTE, ADDTITLE } from '../views/administration/accounts/AddAccountController';
import {
    DELETEROUTE,
    DELETETITLE
} from '../components/tables/administration/accounts/reactAdministrationAccountsTable.directive';

export class AdministrationAccountsRouterStates {
    /** @ngInject */
    constructor($stateProvider) {
        this.$stateProvider = $stateProvider;
    }

    defineStates() {

        this.$stateProvider.state('app.administrationAccounts', {
            url: '/administrationAccounts',
            templateUrl: './app/views/administration/accounts/overview.html',
            controller: 'CommonViewController',
            controllerAs: 'vm',
            params: {
                pageTitle: 'ACCOUNTS'
            }
        }).state(EDITROUTE, {
            url: '/editAccount',
            templateUrl: './app/views/administration/accounts/detail.html',
            controller: 'EditAccountController',
            controllerAs: 'adminAccountController',
            params: {
                id: null,
                pageTitle: EDITTITLE,
                editMode: 'edit'
            }
        }).state(ADDROUTE, {
            url: '/addAccount',
            templateUrl: './app/views/administration/accounts/addAccount.html',
            controller: 'AddAccountController',
            controllerAs: 'adminAccountController',
            params: {
                id: null,
                pageTitle: ADDTITLE,
                editMode: 'create'
            }
        }).state(DELETEROUTE, {
            url: '/deleteAccount',
            controller: 'AdministrationAccountsTableController',
            controllerAs: 'vm',
            onEnter: 'deleteAccounts()',
            params: {
                pageTitle: DELETETITLE
            }
        }).state('administration.deleteAccountConfirmation', {
            url: '/administrationAccountsDelete',
            templateUrl: './app/views/administration/reporting/confirmation.html',
            controller: 'SendReportingDeleteConfirmationController',
            controllerAs: 'deleteConfirmationController',
            params: {
                pKey: 'accountName',
                restUrl: 'noReportingAccountsDelete',
                pageTitle: 'DELETE_ACCOUNT',
                message: 'CONFIRMATION_DELETE_ACCOUNT'
            }
        });
    }
}
